module.exports = __webpack_public_path__ + "img/icon_4.dca0ff46.svg";